import React, { useState, useEffect } from 'react';
import './styles/createuser.scss';
import loading from '../Assets/loading.gif';
import axios from 'axios';

import { server_address as proxy } from '../custom-modules/serverAddress';

import hidden_icon from '../Assets/hidden.png';
import loading_gif from '../Assets/loading.gif';
import error1 from '../Assets/error1.png';


function CreateUser() 
{
    const [is_loaded, set_is_loaded] = useState(false);
    const [is_allowed, set_is_allowed] = useState(false);
    const [is_creating, set_is_creating] = useState(false);
    const [is_created, set_is_created] = useState(false);
    const [create_err, set_create_err] = useState("");
    const [user_info, set_user_info] = useState({});

    // inputs
    const [username_input, set_username_input] = useState("");
    const [password_input, set_password_input] = useState("");
    const [profile_color, set_profile_color] = useState("");

    const profile_colors = [
        "#b81d1d",
        "#2c90b8",
        "#13ba3f",
        "#ba2089",
        "#b1d428"
    ];

    if (!is_loaded)
        {
            if (localStorage.getItem("user-id") == null || localStorage.getItem("user-id") == "")
            {
                set_is_loaded(true);
                set_is_allowed(false);
            }
            else
            {
                axios.post(`${proxy}/isAdmin`, { id: localStorage.getItem("user-id") })
                .then((res) => 
                {
                    let data = res.data;
    
                    if (data == "1")
                    {
                        axios.post(`${proxy}/getUserById`, { id: localStorage.getItem("user-id") })
                            .then((res) => 
                            {

                                // set_users(data);
                                set_is_loaded(true);
                                set_is_allowed(true);
                                set_user_info(res.data[0]);

                                // axios.post(`${proxy}/userData`)
                                //     .then((res) => 
                                //     {
                                //         let data = res.data;
    
                                        
                                //     })
                                //     .catch((err) => console.error(err));
                            })
                            .catch((err) => console.error(err));
                    }
                    else
                    {
                        set_is_loaded(true);
                        set_is_allowed(false);
                    }
                })
                .catch((err) => console.error(err));
            }
        }


    function setup_username_input(value)
    {
        value = value.toString().toLowerCase();

        if (value.includes("@") || value.includes("&") || value.includes("~") || value.includes("|") || value.includes(":") || value.includes(";") || value.includes("?") || value.includes(",") || value.includes("'") || value.includes('"') || value.includes("`") || value.includes("/") || value.includes("#") || value.includes("$") || value.includes("*") || value.includes("!") || value.includes("^") || value.includes(">") || value.includes("<") || value.includes("(") || value.includes(")") || value.includes("[") || value.includes("]") || value.includes("{") || value.includes("}") || value.includes("-") || value.includes("=") || value.includes("+") || value.includes("$") || value.includes("%")) return;
        else set_username_input(value);
    }

    function setup_password_input(value)
    {
        value = value.toString();

        if (value.includes("'") || value.includes('"') || value.includes("`")) return;
        else set_password_input(value);
    }



    function create_account()
    {
        set_create_err("");
        set_is_creating(true);
        let error_text = "";
        let is_valid = true;


        if (profile_color.length == 0)
        {
            error_text = "Please select a profile color!";
            is_valid = false;
        }

        if (password_input.length < 8)
        {
            error_text = "The password must be at least 8 letters!";
            is_valid = false;
        }

        if (username_input.length < 3)
        {
            error_text = "The username is too short!";
            is_valid = false;
        }

        if (username_input.length == 0 || password_input.length == 0) 
        {
            error_text = "Please fill in the blanks!";
            is_valid = false;
        }


        if (!is_valid)
        {
            set_create_err(error_text);
            set_is_creating(false);
            return;
        }


        const date = new Date();
        let date_of_creation = `${(date.getDate().toString().length == 1) ? `0${date.getDate()}` : date.getDate()}/${((date.getMonth() + 1).toString().length == 1) ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1)}/${date.getFullYear()} - ${(date.getHours().toString().length == 1) ? `0${date.getHours()}` : date.getHours()}:${(date.getMinutes().toString().length == 1) ? `0${date.getMinutes()}` : date.getMinutes()}`

        axios.post(`${proxy}/createUser`, { username: username_input, password: password_input, date_of_creation: date_of_creation, color: profile_color })
            .then((res) => 
            {
                let data = res.data;

                if (data == "err")
                {
                    set_create_err("An error occured! Maybe the username already exists.");
                }
                else set_is_created(true);

                set_is_creating(false);
            })
            .catch((err) => console.error(err));
    }

    function return_to_creating()
    {
        set_username_input("");
        set_password_input("");
        set_profile_color("");
        set_is_created(false);
    }



    if (!is_loaded) return (
        <div><img src={loading} style={{ width: "20px" }} /></div>
    );

    if (!is_allowed) return (    
        <div style={{ width: "100%", height: "100vh", display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <img src={error1} style={{ width: "80px" }} />
            <h1>Sorry! This page does not exist!</h1>
            <span>This page might be taken down or you have miss-entered the url!</span>
        </div>);

    if (is_created) return (
        <div className="content-container">
            <div className="panel" style={{ maxWidth: "700px", margin: "auto", textAlign: "center", display: "flex", flexDirection: "column", padding: "10px" }}>
                <h1>Account Information</h1>
                <span><strong>Username: </strong> {username_input}</span>
                <span><strong>Password: </strong> {password_input}</span> <br /> <br />
                <button className="btn" onClick={return_to_creating}>Return</button> <br />
            </div>
        </div>
    );

  return (
    <div className="content-container">
        <div className="panel" style={{ maxWidth: "700px", margin: "auto", textAlign: "center", display: "flex", flexDirection: "column", padding: "10px" }}>
            <h1>Create Chatroom Account</h1> <br /> <br />
            <span>Dear admin, this as you know is a private chatroom. If you want to add another user to the chatroom, create the account over here.</span>
            <span>Please be careful who you let in the chatroom!</span> <br /> <br />
            <div style={{ width: "100%", display: "flex" }}>
                <div className="field" style={{ flexGrow: 1, margin: "5px", padding: "3px" }}><input className="input-field" style={{ fontSize: "15px" }} type="text" value={username_input} placeholder="Username..." maxLength={16} onInput={(e) => setup_username_input(e.target.value)} /></div>
                <div className="field" style={{ flexGrow: 1, margin: "5px", padding: "3px" }}><input className="input-field" style={{ fontSize: "15px" }} type="password" value={password_input} placeholder="Password..." maxLength={20} onInput={(e) => setup_password_input(e.target.value)} /></div>
            </div>
            
            <div className="create-color-pick">
                {
                    profile_colors.map((value, index) => 
                    <div style={(value == profile_color) ? { backgroundColor: value, border: "3px solid rgb(255, 255, 255)" } : { backgroundColor: value }} onClick={() => set_profile_color(value)}></div>)
                }
            </div>
            <span className="error" style={{ color: "red" }}>{create_err}</span>
            <br /> <br />
            {
                (is_creating) ?
                    <img src={loading} style={{ width: "20px" }} />
                    :
                    <button className="btn" onClick={create_account}><strong>Create Account</strong></button>
            } <br /> <br />
            <span><strong>Warning!: </strong>By letting the wrong people using the chatroom, all of the users will lose their privacy, making the chatroom completely useless!</span><br />
            <strong>PLEASE BE WISE!</strong> <br />
        </div>
    </div>
  );
}

export default CreateUser;